import { ca } from '@cian/analytics';
import { IProduct } from '../../types/analytics/products';
import { EInteriorDecorationType } from '../../types/newbuilding/interiorDecoration';

export const trackClickInteriorDecoration = (products: IProduct[]) => (label: EInteriorDecorationType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_finish_jk',
    label,
    products,
  });
};
